import React from "react";

const useClaimStatus = () => {
  const claimStage = (stage = 0) => {
    let statusBadge = "info";
    let claimStatus = "submitted";

    switch (stage) {
      case 1:
        statusBadge = "default";
        break;
      case 2:
        statusBadge = "warning";
        claimStatus = "processing";
        break;
      case 3:
        statusBadge = "danger";
        claimStatus = "declined";
        break;
      case 4:
        // additional info required from client
        statusBadge = "info";
        claimStatus = "info required";
        break;
      case 5:
        statusBadge = "info";
        claimStatus = "cheque written";
        break;
      case 6:
        statusBadge = "success";
        claimStatus = "paid";
        break;
      default:
        statusBadge = "default";
        claimStatus = "opened";
        break;
    }

    return claimStatus;
  };

  return { claimStage };
};

export default useClaimStatus;
